
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.872 2.831a.75.75 0 011.06 0l2.866 2.865a.75.75 0 010 1.061L6.396 14.16a.75.75 0 01-1.061 0L2.47 11.294a.75.75 0 010-1.06L9.872 2.83zm.53 1.591l-6.341 6.342 1.804 1.805 6.342-6.342-1.804-1.805z","fill":"#F8F4EE"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.013 10.034a.75.75 0 01.75.75v2.102h2.073a.75.75 0 010 1.5H3.013a.75.75 0 01-.75-.75v-2.852a.75.75 0 01.75-.75zM8.404 4.304a.75.75 0 011.06-.002L12.34 7.17a.75.75 0 01-1.06 1.062L8.406 5.364a.75.75 0 01-.002-1.06z","fill":"#F8F4EE"}})])
          )
        }
      }
    